export default __webpack_public_path__ + "37d5cadc0aa409f8625b0dc45b45f174.ttf";